import axios from 'axios'
import {
  message
} from 'ant-design-vue'
import bus from '@/utils/Bus'
import i18n from '@/lang/index'
let loadings = {}
// 创建axios实例
const service = axios.create({
  // baseURL: process.env.VUE_APP_PRE_PATH, 
  timeout: 120000 // 请求超时时间
})
let nonce = bus.signObj.randomWord(false, 64); //签名所需
// request拦截器
service.interceptors.request.use(config => {

  startLoading(loadings)
  if (config.method == "post" && !(config.data instanceof FormData)) {
    const bigParams = Object.assign(
      {
        appkey: bus.signObj.appkey, //签名所需
        nonce: nonce,
        timestamp: new Date().getTime() //签名所需
      },
      config.data
    );
    const requestHeaders = {
      //签名所需
      appkey: bus.signObj.appkey,
      nonce: bigParams.nonce,
      timestamp: bigParams.timestamp,
      sign: bus.signObj.returnSign(bigParams)
    };
    config.headers = requestHeaders;
  } else if (config.method == "get") {
    const bigParams = Object.assign(
      {
        appkey: bus.signObj.appkey, //签名所需
        nonce: nonce,
        timestamp: new Date().getTime() //签名所需
      },
      config.params
    );
    const requestHeaders = {
      //签名所需
      appkey: bus.signObj.appkey,
      nonce: bigParams.nonce,
      timestamp: bigParams.timestamp,
      sign: bus.signObj.returnSign(bigParams)
    };
    config.headers = requestHeaders;
  }
  return config
}, error => {
  // Do something with request error
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非20000是抛错 可结合自己业务进行修改
     */
    const res = response.data
    let {
      flag,
      data,
      code
    } = res
    stopLoading(loadings)
    let customCode = bus.errCode
    bus.errCode = -1
    let msg = i18n.t(code) || i18n.t(customCode)
    if (!flag) {
      msg && message.error(msg)
      return Promise.reject('error')
    } else {
      msg && message.success(msg)
      return data
    }
  },
  error => {
    stopLoading(loadings)
    let customCode = bus.errCode || 40001
    message.error(i18n.t(customCode))
    bus.errCode = -1
    return Promise.reject(error)
  }
)

bus.$on('loading', loading => {
  loadings = loading
})

// 开始loaing
function startLoading (loadings) {
  if (Object.prototype.toString.call(loadings) !== '[object Object]') return
  Object.keys(loadings).forEach(item => {
    loadings[item] = true
  })
}
// 停止loading
function stopLoading (loading) {
  if (Object.prototype.toString.call(loading) !== '[object Object]') return
  setTimeout(() => {
    Object.keys(loading).forEach(item => {
      loading[item] = false
    })
    // 清空loading
    loadings = {}
  }, 500);
}
export default service